import { useQuery } from '@apollo/client';
import { graphql } from '@gql/gql';
import type {
  BreederReviewGetBreederQuery,
  BreederReviewGetBreederQueryVariables,
} from '@gql/graphql';
import { useMemo } from 'react';

export const BREEDER_REVIEW_GET_BREEDER = graphql(`
  query BreederReviewGetBreeder($where: DogBreederWhereInput!, $take: Int) {
    findManyDogBreeder(where: $where, take: $take) {
      id
      displayName
      reviews {
        id
        globalGrade
        accountId
      }
    }
  }
`);

export const useGetBreeder = (id: string) => {
  const variables = useMemo((): BreederReviewGetBreederQueryVariables => {
    return {
      take: 1,
      where: {
        AND: [
          { translations: { some: { url: { equals: id } } } },
          { certified: { equals: true } },
          { public: { equals: true } },
        ],
      },
    };
  }, [id]);

  const { data, error, loading } = useQuery<
    BreederReviewGetBreederQuery,
    BreederReviewGetBreederQueryVariables
  >(BREEDER_REVIEW_GET_BREEDER, {
    variables,
    skip: id == null,
  });

  const breeder = useMemo(() => {
    return data?.findManyDogBreeder?.[0];
  }, [data?.findManyDogBreeder]);

  return {
    breeder,
    breederError: error,
    breederLoading: loading,
  };
};
